export var PoolRealtimeState = /* @__PURE__ */ ((PoolRealtimeState2) => {
  PoolRealtimeState2["AVAILABLE"] = "AVAILABLE";
  PoolRealtimeState2["UNAVAILABLE"] = "UNAVAILABLE";
  PoolRealtimeState2["OUT_OF_ORDER"] = "OUT_OF_ORDER";
  PoolRealtimeState2["FAULTED"] = "FAULTED";
  PoolRealtimeState2["UNKNOWN"] = "UNKNOWN";
  return PoolRealtimeState2;
})(PoolRealtimeState || {});
export var AdministrativeState = /* @__PURE__ */ ((AdministrativeState2) => {
  AdministrativeState2[AdministrativeState2["PLANNED"] = 1] = "PLANNED";
  AdministrativeState2[AdministrativeState2["IN_DEPLOYMENT"] = 2] = "IN_DEPLOYMENT";
  AdministrativeState2[AdministrativeState2["IN_MAINTENANCE"] = 3] = "IN_MAINTENANCE";
  AdministrativeState2[AdministrativeState2["IN_SERVICE"] = 4] = "IN_SERVICE";
  AdministrativeState2[AdministrativeState2["OUT_OF_SERVICE"] = 5] = "OUT_OF_SERVICE";
  AdministrativeState2[AdministrativeState2["DELETED"] = 6] = "DELETED";
  return AdministrativeState2;
})(AdministrativeState || {});
export var PoolOverallState = /* @__PURE__ */ ((PoolOverallState2) => {
  PoolOverallState2["AVAILABLE"] = "AVAILABLE";
  PoolOverallState2["OCCUPIED"] = "OCCUPIED";
  PoolOverallState2["FUNCTIONAL"] = "FUNCTIONAL";
  PoolOverallState2["UNKNOWN_WITH_REAL_TIME"] = "UNKNOWN_WITH_REAL_TIME";
  PoolOverallState2["UNKNOWN_WITHOUT_REAL_TIME"] = "UNKNOWN_WITHOUT_REAL_TIME";
  PoolOverallState2["OUT_OF_ORDER_WITH_REAL_TIME"] = "OUT_OF_ORDER_WITH_REAL_TIME";
  PoolOverallState2["OUT_OF_ORDER_WITHOUT_REAL_TIME"] = "OUT_OF_ORDER_WITHOUT_REAL_TIME";
  return PoolOverallState2;
})(PoolOverallState || {});
